export const ANSWER = `{
  exam_id
  id
  total_time_needed_in_ms
  language
  attempts
  os
}`
